var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6875 0.5C39.9531 0.5 38 2.64844 38 5.1875V38H20.8125C17.2969 38 15.5391 42.2969 18.0781 44.8359L47.7656 74.5234C49.1328 75.8906 51.6719 75.8906 53.0391 74.5234L82.7266 44.8359C85.2656 42.2969 83.5078 38 79.9922 38H63V5.1875C63 2.64844 60.8516 0.5 58.3125 0.5H42.6875ZM100.5 73.9375C100.5 71.3984 98.3516 69.25 95.8125 69.25H67.1016L57.5312 78.8203C53.625 82.9219 47.1797 82.9219 43.2734 78.8203L33.7031 69.25H5.1875C2.45312 69.25 0.5 71.3984 0.5 73.9375V95.8125C0.5 98.5469 2.45312 100.5 5.1875 100.5H95.8125C98.3516 100.5 100.5 98.5469 100.5 95.8125V73.9375ZM76.2812 91.125C76.2812 93.2734 74.5234 95.0312 72.375 95.0312C70.2266 95.0312 68.4688 93.2734 68.4688 91.125C68.4688 88.9766 70.2266 87.2188 72.375 87.2188C74.5234 87.2188 76.2812 88.9766 76.2812 91.125ZM88.7812 91.125C88.7812 93.2734 87.0234 95.0312 84.875 95.0312C82.7266 95.0312 80.9688 93.2734 80.9688 91.125C80.9688 88.9766 82.7266 87.2188 84.875 87.2188C87.0234 87.2188 88.7812 88.9766 88.7812 91.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloads);
export default __webpack_public_path__ + "static/media/downloads.34f8aed1c83e15cc0999c64cee72e4bc.svg";
export { ForwardRef as ReactComponent };